export default [
  {
    path: '/atschool/summary',
    name: 'PageAtSchoolSummary',
    component: () =>
      import(
        /* webpackChunkName: "atschool" */ '../pages/atschool/PageAtSchoolSummary'
      ),
    meta: {
      modular: 161,
      title: '在校统计',
      info: '在校统计--首页',
      keepAlive: true
    }
  },
  {
    path: '/atschool/statistics',
    name: 'PageAtSchoolStatistics',
    component: () =>
      import(
        /* webpackChunkName: "atschool" */ '../pages/atschool/PageAtSchoolStatistics'
      ),
    meta: {
      modular: 161,
      title: '在校统计',
      info: '在校统计——统计详情',
      keepAlive: true
    }
  },
  {
    path: '/atschool/batch/modify',
    name: 'PageAtSchoolBatchModify',
    component: () =>
      import(
        /* webpackChunkName: "atschool" */ '../pages/atschool/PageAtSchoolBatchModify'
      ),
    meta: {
      modular: 161,
      title: '批量修改为在校',
      info: '在校统计——批量修改为在校',
      keepAlive: true
    }
  },
  {
    path: '/atschool/summary/exclude',
    name: 'PageAtSchoolSummaryExclude',
    component: () =>
      import(
        /* webpackChunkName: "atschool" */ '../pages/atschool/PageAtSchoolSummaryExclude'
      ),
    meta: {
      modular: 161,
      title: '不参与统计的学生',
      info: '在校统计——不参与统计的学生',
      keepAlive: true
    }
  },
  {
    path: '/atschool/member/details',
    name: 'PageAtSchoolMemberDetails',
    component: () =>
      import(
        /* webpackChunkName: "atschool" */ '../pages/atschool/PageAtSchoolMemberDetails'
      ),
    meta: {
      modular: 161,
      title: '详情',
      info: '在校统计——详情',
      keepAlive: true,
      immediate: true
    }
  }
]
